"use strict";

exports.__esModule = true;
exports.useUiDesign = useUiDesign;
var _react = require("react");
var _UiDesignContext = require("./UiDesignContext");
/**
 * `{ modern, screen }` for the nearest UiDesignProvider.
 */
function useUiDesign() {
  return (0, _react.useContext)(_UiDesignContext.UiDesignContext);
}